
import { RatingDto, RatingFormDto } from '@/types/rating.type';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class RateShiftModal extends Vue {
  @Prop({ default: null }) rating!: RatingDto | null;

  form = new RatingFormDto();

  get details(): string {
    if (!this.rating) {
      return "";
    }

    return [
      new Date(this.rating.startDateOnly).toISOString().split('T')[0],  
      this.rating.shiftPosition,
      new Date(this.rating.shiftStartDateTime).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })
    ].join(' · ')
  }

  save(): void {
    if (!this.rating) {
      return;
    }

    this.form.id = this.rating.id;

    this.$emit('save', this.form);

    this.form = new RatingFormDto();
  }

  dismiss(): void {
    if (!this.rating) {
      return;
    }

    this.form.id = this.rating.id;

    this.$emit('dismiss', this.form);

    this.form = new RatingFormDto();
  }

  onClose(): void {
    this.form = new RatingFormDto();
  }
}
